var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selects"},[(!_vm.selects)?_c('loading'):_vm._e(),(_vm.selects)?_c('div',[_c('select-table',{attrs:{"selects":_vm.selects,"has_more":_vm.has_more,"loading":_vm.loading}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }